import { CancelButton, EditButton } from '@core/components/Buttons';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { TextLabel } from '@core/components/Inputs';
import DateLabel from '@core/components/Inputs/DateLabel';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { Grid } from '@material-ui/core';
import { getCurrency } from 'app/utils/monetarioUtil';
import React, { useContext } from 'react';
import { FaCreditCard } from 'react-icons/fa';
import { ContaContext } from '../../../ContaContext';
import { modaisConta } from '../modais';
import { contaModalStyles } from '../modalStyles';

const tiposContas = {
  CORRENTE: 'Corrente',
  POUPANCA: 'Poupança',
  INVESTIMENTO: 'Investimento',
};

const VisualizarContaBancariaModal = () => {
  const [modal, setModal] = useContext(ContaContext).modal;
  const [conta] = useContext(ContaContext).contaAtual;
  const [bancos] = useContext(ContaContext).bancos;

  const modalStyles = contaModalStyles();

  const handleCloseModal = () => {
    setModal(false);
  };

  const handleOpenEditMode = () => {
    setModal(modaisConta.editarContaBancaria);
  };

  const getBanco = (bancoId) => {
    if (!bancoId) {
      return false;
    }
    const [banco] = bancos.filter((b) => b.id === bancoId);

    return `${banco?.codigo ? `${banco?.codigo} - ` : ''} ${banco?.nome}`;
  };

  const Content = () => {
    return (
      <div className={modalStyles.container}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <TextLabel id="descricao" label="Descrição" value={conta?.descricao} />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <TextLabel id="tipoConta" label="Tipo da conta" value={tiposContas[conta?.contaBancaria?.tipoConta]} />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextLabel id="banco" label="Banco" value={getBanco(conta?.contaBancaria?.bancoId)} />
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
            <TextLabel id="agencia" label="Agência" value={conta?.contaBancaria?.agencia} />
          </Grid>
          <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
            <TextLabel id="agenciaDigito" label="Dígito" value={conta?.contaBancaria?.agenciaDigito} />
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
            <TextLabel id="conta" label="Conta" value={conta?.contaBancaria?.numeroConta} />
          </Grid>
          <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
            <TextLabel id="contaDigito" label="Dígito" value={conta?.contaBancaria?.contaDigito} />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <TextLabel
              id="saldoInicial"
              label="Saldo Inicial (R$)"
              value={getCurrency(conta?.contaBancaria?.saldoInicial)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <DateLabel id="dataSaldo" label="Data do saldo" value={conta?.contaBancaria?.dataSaldo} />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <DateLabel
              id="dataEncerramento"
              label="Data do encerramento"
              value={conta?.contaBancaria?.dataEncerramento}
            />
          </Grid>
        </Grid>
      </div>
    );
  };

  return (
    <SimpleDialog open={modal === modaisConta.visualizarContaBancaria} onClose={handleCloseModal}>
      <SimpleDialogContent
        header={{
          title: 'Cadastro de conta bancária',
          icon: <FaCreditCard />,
          toolbar: (
            <>
              <CancelButton onClick={handleCloseModal}>Fechar</CancelButton>
              {permissaoUtils.conta().editar && (
                <EditButton id="add-classe-root" type="submit" onClick={handleOpenEditMode}>
                  Editar
                </EditButton>
              )}
            </>
          ),
        }}
        content={<Content />}
      />
    </SimpleDialog>
  );
};

export default VisualizarContaBancariaModal;
